import axios from "axios";
import apiClient from "@/features/dashboard/api/axios";

const url = {
  getMarkUpTrend: () => "/dashboards/markup-trend",
  getMarkUpTrendBrandList: () => "/dashboards/markup-trend/brand-list",
};

export const dashboardMarkupTrendApi = {
  getMarkUpTrend: (params: { brand_ids: string[] }) =>
    apiClient.get(url.getMarkUpTrend(), {
      params,
    }),
  getMarkUpTrendBrandList: () => apiClient.get(url.getMarkUpTrendBrandList()),
};
